import React, { useEffect, useState } from 'react';
import SubunitTable from './SubunitTable';
import { Button, Divider, Form, Space, Typography } from 'antd';
import SubunitAdd from '../SubunitAdd';
import { getSubunits } from '../../../services/subunitService';
import { getParams } from '../../../utilities/filterConstructor';
import SubunitSearch from './SubunitSearch';

const { Title } = Typography;

const Subunits = () => {
  const [visibleAddModal, setVisibleAddModel] = useState(false);
  const onClickModal = () => {
    setVisibleAddModel(true);
  };

  const [current, setCurrent] = useState(1);
  const [pageSize, setPageSize] = useState(20);
  const [offset, setOffset] = useState((current - 1) * pageSize);

  const [subunits, setSubunits] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [filteredParams, setFilteredParams] = useState({});
  const [error, setError] = useState(false);
  const [currentParams, setCurrentParams] = useState({});
  const [fetching, setFetching] = useState(false);

  const getData = async (
    newParams,
    limit = pageSize,
    currentPage = current
  ) => {
    const params = newParams ? newParams : currentParams;
    setFetching(true);
    await getSubunits(currentPage, limit, params)
      .then((res) => {
        if (!res.error) {
          setSubunits(res.data.paginatedList);
          setTotalCount(res.data.totalCount);
        } else {
          console.log(res.error);
          setError(error);
        }
        setFetching(false);
      })
      .catch((e) => {
        console.log(e);
        setFetching(false);
      });
  };

  const onPaginationChange = (data) => {
    getData(currentParams, data.pageSize, data.current);
    setCurrent(data.current);
    setPageSize(data.pageSize);
    setOffset((data.current - 1) * data.pageSize);
  };

  useEffect(() => {
    getData();
  }, [current, currentParams]);

  const [form] = Form.useForm();

  const onSearch = (data) => {
    const params = getParams(data);
    console.log('params on subunits data thing', params);
    setCurrentParams(params);
    setCurrent(1);
  };

  const onReset = () => {
    form.resetFields();
    setOffset(0);
    setCurrent(1);
    getData({}, pageSize, 1);
  };

  return (
    <div>
      <div>
        <Space size="large">
          <Title level={3}>Subunits</Title>
          <Button type="ghost" onClick={onClickModal}>
            Add
          </Button>

          <SubunitAdd
            isOpen={visibleAddModal}
            toggle={() => setVisibleAddModel(false)}
          />
        </Space>
        <section>
          <SubunitSearch
            onSearch={onSearch}
            onReset={onReset}
            form={form}
            initialValues={{ param: 'subunitSearch' }}
          />
        </section>
        <section>
          <SubunitTable
            data={subunits}
            currentParams={currentParams}
            setFilteredParams={setFilteredParams}
            onPaginationChange={onPaginationChange}
            current={current}
            totalCount={totalCount}
            offset={offset}
            fetching={fetching}
          />
        </section>
      </div>
    </div>
  );
};

export default Subunits;
